export default "__VITE_ASSET__546cf3fa__"